import React, { useEffect } from "react";
import SkillBar from "react-skillbars";
import { useSelector, useDispatch } from "react-redux";
import { getSkills } from "../../../actions/skillAction";
import { useTranslation } from "react-i18next";
import "./skills.css";
import NeonHeading from "../NeonHeading/NeonHeading";

const Skills = ({ reff }) => {
  const { t } = useTranslation();
  const skills = useSelector((state) => state.skills);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSkills());
  }, [dispatch]);

  const colors = {
    bar: "#3498db",
    title: {
      text: "#fff",
      background: "#2980b9",
    },
  };

  return (
    <div ref={reff} className="pt-0 pb-5" style={{ backgroundColor: "#fff" }}>
      <div className="container">
        <NeonHeading color="orange">
          {t('fo9.21')}
        </NeonHeading>
        <SkillBar
          skills={skills}
          colors={colors}
          animationDuration={2000}
          height={50}
          offset={50} // Başlık ile bar arasındaki boşluğu azalt
          className="custom-skillbar"
        ></SkillBar>
      </div>
    </div>
  );
};

export default Skills;
